import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { getLocationsList, getLocationById, updateLocation } from "./thunks";

const LocationsAdapter = createEntityAdapter({
  selectId: (location) => location.id
});

const initialState = LocationsAdapter.getInitialState({
  metadata: {},
  currentLocation: {},
  search: ""
});

export const locationsSlice = createSlice({
  name: "adminSavedLocations",
  initialState,
  reducers: {
    updatePaginationLocations(state, action) {
      const oldMeta = state.metadata;
      state.metadata = {
        ...oldMeta,
        ...action.payload
      };
    },
    updateSearchLocations(state, action) {
      state.search = action.payload;
    },
    clearCurrentLocation(state) {
      state.currentLocation = {};
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getLocationsList.fulfilled, (state, { payload }) => {
      LocationsAdapter.setAll(state, payload || []);
      state.metadata = {};
    });
    builder.addCase(getLocationById.fulfilled, (state, { payload }) => {
      state.currentLocation = payload || {};
    });
    builder.addCase(updateLocation.fulfilled, (state, { payload }) => {
      // Update the location in the list if it exists
      if (state.currentLocation.id) {
        state.currentLocation = { ...state.currentLocation, ...(payload || {}) };
      }
    });

    // Handle error cases
    builder.addCase(getLocationsList.rejected, (state) => {
      LocationsAdapter.setAll(state, []);
      state.metadata = {};
    });
    builder.addCase(getLocationById.rejected, (state) => {
      state.currentLocation = {};
    });
  }
});

export const {
  selectById: selectLocationById,
  selectIds: selectLocationIds,
  selectEntities: selectLocationEntities,
  selectAll: selectAllLocations,
  selectTotal: selectTotalLocations
} = LocationsAdapter.getSelectors((state) => state.adminSavedLocations);

export const selectMetadata = (state) => state.adminSavedLocations.metadata;
export const selectCurrentLocation = (state) => state.adminSavedLocations.currentLocation;
export const selectSearch = (state) => state.adminSavedLocations.search;

export const { updatePaginationLocations, updateSearchLocations, clearCurrentLocation } =
  locationsSlice.actions;

export default locationsSlice.reducer;
